import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../contexts/StoreContext';
import { useStoreAlerts } from '../../hooks/useStoreAlerts';
import MobileAlertsFab from './MobileAlertsFab';

/** Bouton d'alertes de la barre de navigation desktop (même store partagé que les pages). */
const HeaderAlerts: React.FC = () => {
  const { currentStore } = useStore();
  const navigate = useNavigate();
  const { alerts } = useStoreAlerts(currentStore?.id);

  const handleAlertClick = (searchId: number, count?: number) => {
    const params = new URLSearchParams();
    params.set('savedSearchId', String(searchId));
    if (typeof count === 'number' && count >= 0) params.set('dashboardCount', String(count));
    navigate(`/orders?${params.toString()}`);
  };

  return <MobileAlertsFab inline alerts={alerts} onAlertClick={handleAlertClick} />;
};

export default HeaderAlerts;